import { Component } from '@angular/core';

@Component({
  selector: 'app-privliege-edit',
  templateUrl: './privliege-edit.component.html',
  styleUrls: ['./privliege-edit.component.scss']
})
export class PrivliegeEditComponent {

}
